import React from 'react';
import styled from 'styled-components';
import { Separator } from '../../../shared/sectionable/styles';
import Type from '../../../shared/fund/type';
import WholesaleTag from '../../../shared/fund/wholesale-tag';
import { fundCardDefaultPropTypes, fundCardPropTypes } from '../../common/prop-types';
import {
  Primary,
  Bottom,
  AssetClass,
  Container,
  Name,
  Top,
  FlexRow,
} from './styles';
import Logo from './logo';
import Summary from './summary';
import Performance from './performance';
import Fees from './fees';

const MobileFlexRow = styled(FlexRow)`
  .tag-container {
    height: 13px;
    font-size: 8px;
  }
`;

export default function MobileOrTablet(props) {
  const {
    name,
    fundType,
    fundAssetClass,
    inceptionDate,
    minimumInvestment,
    managementFee,
    performanceFee,
    isPerformanceFeeCharged,
    totalCostRatio,
    financialYearEndFeesDate,
    returnSinceInception,
    oneMonthReturnPercent,
    oneYearReturnPercent,
    threeYearReturnPercent,
    fiveYearReturnPercent,
    logoColor,
    logoPictureUrl,
    currentView,
    wholesale,
  } = props;

  return (
    <Container>
      <Top>
        <Logo color={logoColor} url={logoPictureUrl} />
        <Primary>
          <MobileFlexRow>
            {!!fundType && <Type type={fundType} />}
            {wholesale && <WholesaleTag />}
          </MobileFlexRow>
          <Name>{name}</Name>
          <AssetClass>{fundAssetClass}</AssetClass>
        </Primary>
      </Top>
      <Separator />
      <Bottom>
        {currentView === 'summary' && (
          <Summary
            minimumInvestment={minimumInvestment}
            managementFee={managementFee}
            returnSinceInception={returnSinceInception}
            inceptionDate={inceptionDate}
          />
        )}
        {currentView === 'performance' && (
          <Performance
            inceptionDate={inceptionDate}
            oneMonthReturnPercent={oneMonthReturnPercent}
            oneYearReturnPercent={oneYearReturnPercent}
            threeYearReturnPercent={threeYearReturnPercent}
            fiveYearReturnPercent={fiveYearReturnPercent}
            returnSinceInception={returnSinceInception}
          />
        )}
        {currentView === 'fees' && (
          <Fees
            managementFee={managementFee}
            performanceFee={performanceFee}
            isPerformanceFeeCharged={isPerformanceFeeCharged}
            totalCostRatio={totalCostRatio}
            financialYearEndFeesDate={financialYearEndFeesDate}
          />
        )}
      </Bottom>
    </Container>
  );
}

MobileOrTablet.propTypes = fundCardPropTypes;
MobileOrTablet.defaultProps = fundCardDefaultPropTypes;
